<div class="tooltip">
  <div class="tooltip__item">
    <div class="tooltip__name">Supervisor:</div>
    <div [class.signed]="data?.supervisor" class="tooltip__value">
      <i
        [class.icon-v2-checkmark-circle]="data?.supervisor"
        [class.icon-v2-lose-circle]="!data?.supervisor"
      ></i>
      {{ data?.supervisor ? 'Signed' : 'Not signed' }}
    </div>
  </div>
  <div class="tooltip__item">
    <div class="tooltip__name">Patient:</div>
    <div [class.signed]="data?.patient" class="tooltip__value">
      <i
        [class.icon-v2-checkmark-circle]="data?.patient"
        [class.icon-v2-lose-circle]="!data?.patient"
      ></i>
      {{ data?.patient ? 'Signed' : 'Not signed' }}
    </div>
  </div>
  <div class="tooltip__item">
    <div class="tooltip__name">DCW:</div>
    <div [class.signed]="data?.hha1" class="tooltip__value">
      <i
        [class.icon-v2-checkmark-circle]="data?.hha1"
        [class.icon-v2-lose-circle]="!data?.hha1"
      ></i>
      {{ data?.hha1 ? 'Signed' : 'Not signed' }}
    </div>
  </div>

  @for (key of Object.keys(data); track $index) {
    @if ((key !== 'patient' && key !== 'supervisor' && key !== 'hha1')) {
      <div [class.signed]="data?.[key]" class="tooltip__item">
        <div class="tooltip__name">DCW:</div>
        <div [class.signed]="data?.[key]" class="tooltip__value">
          <i
            [class.icon-v2-checkmark-circle]="data?.[key]"
            [class.icon-v2-lose-circle]="!data?.[key]"
          ></i>
          {{ data?.[key] ? 'Signed' : 'Not signed' }}
        </div>
      </div>
    }
  }
</div>
